import { withStateHandlers } from 'recompose';

export default withStateHandlers(
  {
    batchProgress: {
      total: 0,
      submitted: 0,
      successful: 0,
      failed: 0,
      inProgress: false,
      results: [], // Array of { batchNumber, status: 'success' | 'error', transferId, error }
    }
  },
  {
    updateBatchProgress: () => (updates) => ({
      batchProgress: updates
    }),
    resetBatchProgress: () => () => ({
      batchProgress: {
        total: 0,
        submitted: 0,
        successful: 0,
        failed: 0,
        inProgress: false,
        results: []
      }
    })
  }
);
